import { useCallback, useEffect, useState } from 'react'

function readNavigatorOnline(): boolean {
  return typeof navigator === 'undefined' ? true : navigator.onLine
}

/** Detecta conectividad real del dispositivo (`navigator.onLine` + eventos `online`/`offline`).
 * `recheck` permite al usuario forzar una relectura manual desde el botón "Reintentar" del
 * estado sin conexión, sin recargar la aplicación. */
export function useOnlineStatus(): { isOnline: boolean; recheck: () => void } {
  const [isOnline, setIsOnline] = useState(readNavigatorOnline)

  useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)
    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  const recheck = useCallback(() => setIsOnline(readNavigatorOnline()), [])

  return { isOnline, recheck }
}
